import React, { Component } from "react";
import { Spin, message, Radio, Space } from "antd";
import Bridge from "../../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { speech_demographics_form_type } from "../../../utils/consts";


export default class MedicalHistoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      bipolar_disorder: "",
      brain_aneurysm: "",
      cancer: "",
      depression: "",
      diabetes: "",
      epilepsy: "",
      muscle_disease: "",
      schizophrenia: "",
      other:"",
      other_specification:"",

      email:"",
      neurostamp_id:"",
      modality_id:"",

      options:[
        {
          label:"Yes",
          value:"1"
        },
        {
          label:"No",
          value:"2"
        },
      ],
      field_data:[]
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.medical_history;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          if (response.data.length > 0) {
            this.setState({
              email:response.email,
              neurostamp_id:response.neurostamp_id,
              modality_id:response.modality_id,
              field_data:response.field_data.medical_history
            })
            for(let item of response.data){
              if(item.field=='MEDHXBP'){
                this.setState({bipolar_disorder: item.value})
              }
              if(item.field=='MEDHXBA'){
                this.setState({brain_aneurysm: item.value})
              }
              if(item.field=='MEDHXCNR'){
                this.setState({cancer: item.value})
              }
              if(item.field=='MEDHXDP'){
                this.setState({depression: item.value})
              }
              if(item.field=='MEDHXDB'){
                this.setState({diabetes: item.value})
              }
              if(item.field=='MEDHXEP'){
                this.setState({epilepsy: item.value})
              }   
              if(item.field=='MEDHXMD'){
                this.setState({muscle_disease: item.value})
              }   
              if(item.field=='MEDHXSP'){
                this.setState({schizophrenia: item.value})
              }   
              if(item.field=='MEDHXOTH'){
                this.setState({other: item.value})
              }   
              if(item.field=='MEDHXOTL'){
                this.setState({other_specification: item.value})
              }   
            }
            this.setState({loading:false})
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  // step 1
  save_details = () => {

    // Validation for conditions that require specification when 'Yes' is selected
    var conditionsToValidate = [
      { field: 'bipolar_disorder', label: 'Bipolar Disorder' },
      { field: 'brain_aneurysm', label: 'Brain Aneurysm' },
      { field: 'cancer', label: 'Cancer' },
      { field: 'depression', label: 'Depression' },
      { field: 'diabetes', label: 'Diabetes' },
      { field: 'epilepsy', label: 'Epilepsy' },
      { field: 'muscle_disease', label: 'Muscle Disease' },
      { field: 'schizophrenia', label: 'Schizophrenia' },
      { field: 'other', label: 'Other' },      
    ];

    for (let condition of conditionsToValidate) {
      if (!this.state[condition.field]) {
        message.warning(`Please select value of '${condition.label}' field`);
        return;
      }
    }

    // Validation for 'Other' medical condition
    if (this.state.other === "1" && !this.state.other_specification) {
      message.warning("Please specify the details for 'Other' medical condition");
      return;
    }
    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='MEDHXBP'){
        let obj={
          value:this.state.bipolar_disorder,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='MEDHXBA'){
        let obj={
          value:this.state.brain_aneurysm,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='MEDHXCNR'){
        let obj={
          value:this.state.cancer,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='MEDHXDP'){
        let obj={
          value:this.state.depression,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='MEDHXDB'){
        let obj={
          value:this.state.diabetes,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='MEDHXEP'){
        let obj={
          value:this.state.epilepsy,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }   
      if(item.field=='MEDHXMD'){
        let obj={
          value:this.state.muscle_disease,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }   
      if(item.field=='MEDHXSP'){
        let obj={
          value:this.state.schizophrenia,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }   
      if(item.field=='MEDHXOTH'){
        let obj={
          value:this.state.other,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }   
      if(item.field=='MEDHXOTL'){
        let obj={
          value:this.state.other_specification,
          view_name:item.view_name,
          form:"Medical History",
          field: item.field
        }
        questions.push(obj) 
      }   
    }   
    let params = {
      data: JSON.stringify(questions),
      step: speech_demographics_form_type.medical_history,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                if(this.props.is_non_als_user==true){
                  this.props.set_active_step(10);
                }else{
                  this.props.set_active_step(9);
                }
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Medical History</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
          <div className="col-lg-12">
              <label className="mb-2 input-heading">
                Do you have a history of any of the following?:
              </label>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Bipolar Disorder
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ bipolar_disorder: e.target.value })
                  }
                  value={this.state.bipolar_disorder}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  {" "}
                  Brain Aneurysm
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ brain_aneurysm: e.target.value })
                  }
                  value={this.state.brain_aneurysm}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                        return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Cancer
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ cancer: e.target.value })}
                  value={this.state.cancer}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Depression
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ depression: e.target.value })
                  }
                  value={this.state.depression}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Diabetes
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ diabetes: e.target.value })}
                  value={this.state.diabetes}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Epilepsy
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ epilepsy: e.target.value })}
                  value={this.state.epilepsy}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Muscle Disease
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ muscle_disease: e.target.value })
                  }
                  value={this.state.muscle_disease}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Schizophrenia
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ schizophrenia: e.target.value })
                  }
                  value={this.state.schizophrenia}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Other
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ 
                      other: e.target.value,
                      other_specification:""
                     })
                  }
                  value={this.state.other}
                >
                  <Space direction="horizontal">
                    {this.state.options.map((item,index)=>{
                      return(
                        <Radio value={item.value} key={index}>{item.label}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
                <br/>
                {this.state.other=='1' && (
                  <div className="form-group mt-4">
                    <div className="col-lg-12">
                      <label className="mb-2 input-heading">
                        Other, please specify:
                        <span className="text-danger">*</span>
                      </label><br/>
                      <input
                        type={"text"}
                        value={this.state.other_specification}
                        onChange={(e) =>
                          this.setState({ other_specification: e.target.value })
                        }
                        placeholder="Other, please specify"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{padding: "9px 28px 10px 21px"}}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(6)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
